<template>
    <div id="classadd">
        <headers title="班级"></headers>
        <div class="tips">请选择你要加入的班级</div>
        <div class="list">
            <div class="item flex jb ac">
                <div class="title" >地市：</div>
                <div class="choose flex ac" :class="areaInfo.county_id ? 'active' : ''" @click="choose_area">
                    <p>{{ areaInfo.areaname||'请选择地市' }}</p>
                    <img src="./img/icon_right.png" class="icon_right" />
                </div>
            </div>
            <div class="item flex jb ac">
                <div class="title">学校：</div>
                <div class="choose flex ac" :class="schoolInfo.school_id ? 'active' : ''" @click="choose_school">
                    <p>{{ schoolInfo .school_name || '请选择学校' }}</p>
                    <img src="./img/icon_right.png" class="icon_right" />
                </div>
            </div>
            <div class="item flex jb ac">
                <div class="title">班级：</div>
                <div class="choose flex ac" :class="unitInfo[2] ? 'active' : ''" @click="choose_unit">
                    <p v-if="unitInfo[0]">{{ unitInfo[0].label.slice(0,2)+ unitInfo[1].value+ unitInfo[2].value }}班</p>
                    <p v-else>请选择班级</p>
                    <img src="./img/icon_right.png" class="icon_right" />
                </div>
            </div>
        </div>
        <div class="btn" :class="areaInfo.county_id&& schoolInfo.school_id&& unitInfo[2]?'active':''" @click="join_class">确定</div>
        <!-- 选择地市 -->
        <VuePicker :data="pickData"
          :layer="2"
          :showToolbar="true"
          @confirm="confirm"
          :visible.sync="pickerVisible"
        />
        <!-- 选择班级 -->
        <VuePicker :data="unitData"
          :layer="3"
          :showToolbar="true"
          @confirm="confirm2"
          :visible.sync="pickerVisible2"
        />
    </div>
</template>
<script type="text/ecmascript-6">
    import headers from "COMPONENTS/base/header.vue";
    import VuePicker from 'vue-pickers'

    export default {
        components: {
            headers,
            VuePicker
        },
        data() {
            return {
                loading: false,
                pickerVisible: false,
                pickerVisible2: false,
                pickData: [],//地市数据
                unitData: [],//班级数据
                areaInfo: localStorage.getItem('areaInfo')? JSON.parse(localStorage.getItem('areaInfo')):{},
                schoolInfo: localStorage.getItem('schoolInfo')? JSON.parse(localStorage.getItem('schoolInfo')):{},
                unitInfo: [],
            }
        },
        created(){
            this.getPickData()
        },
        methods: {
            getPickData(){
                this.$http.post(API_URL_BASE_API + '/unit/area/area_list/').then(res => {
                    if (res.data.response == 'ok') {
                        let _arr = []
                        res.data.data.area_list.forEach(e => {
                            let obj = {}
                            obj.label = e.city_name
                            obj.value = e.city_id
                            obj.children = []
                            e.county_list.forEach(i => {
                                let obj2 = {}
                                obj2.label = i.county_name
                                obj2.value = i.county_id
                                obj.children.push(obj2)
                            })
                            _arr.push(obj)
                        });
                        this.pickData = _arr
                    } else {
                        layer.tips(res.data.message)
                    }
                })
            },
            choose_area() {
                this.pickerVisible = true
            },
            choose_school () {
                if(!this.areaInfo.county_id){
                    layer.tips('请先选择地市')
                    return
                }
                this.$router.push('/classlist/school/'+this.areaInfo.county_id)
            },
         
            confirm (res) {
                this.areaInfo.areaname =res[0].label+ res[1].label
                this.areaInfo.county_id= res[1].value
                let obj={
                    areaname: res[0].label + res[1].label,
                    county_id:res[1].value
                }
                localStorage.setItem('areaInfo',JSON.stringify(obj))
            },
            choose_unit(){
                if (!this.areaInfo.county_id) {
                    layer.tips('请先选择地市')
                    return
                }
                if (!this.schoolInfo.school_id) {
                    layer.tips('请先选择学校')
                    return
                }
                this.unitData=[]
                this.$http.post(API_URL_BASE_API + '/unit/area/school/max_class',{
                    school_id:this.schoolInfo.school_id
                }).then(res => {
                    if (res.data.response == 'ok') {
                        //组合picker需要的数据
                        res.data.data.forEach(e=>{
                            let obj = { }
                            obj.value = e.type
                            obj.label= e.unit_name
                            obj.children= []
                            e.grade_list.forEach(j=>{
                                let obj2={}
                                obj2.value = j.grade_id
                                obj2.label = j.unit_name
                                obj2.children = []
                                j.class_list.forEach(i=>{
                                    let obj3 = {}
                                    let unit_id=''
                                    if(i.id<10){
                                        unit_id ='0'+ i.id
                                    }else{
                                        unit_id =  i.id
                                    }
                                    obj3.value = unit_id
                                    obj3.label = i.value
                                    obj2.children.push(obj3)
                                })
                                obj.children.push(obj2)
                            })
                            this.unitData.push(obj)
                        })
                        this.pickerVisible2=true
                    } else {
                        layer.tips(res.data.message)
                    }
                })
            },
            confirm2 (res) {
                this.unitInfo=res
            },
            join_class(){
                if (!this.areaInfo.county_id) {
                    layer.tips('请先选择地市')
                    return
                }
                if (!this.schoolInfo.school_id) {
                    layer.tips('请先选择学校')
                    return
                }
                if (!this.unitInfo[2]) {
                    layer.tips('请先选择班级')
                    return
                }
                let data={
                    school_id: this.schoolInfo.school_id,
                    user_type: 3,
                    type: 1,
                    sid: JSON.parse(localStorage.getItem('info')).sid,
                    grade_id: this.unitInfo[1].value,
                    dept_id: this.unitInfo[0].value,
                    class_id: this.unitInfo[2].value,
                }
                
                this.$http.post(API_URL_BASE_API + '/unit/region/join_class/', data).then(res => {
                    if (res.data.response == 'ok') {
                        layer.tips(res.data.message)
                        this.$router.go(-1)
                    } else {
                        layer.tips(res.data.message)
                    }
                })
            }
        },
       
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .flex {
        display: flex;
    }

    .jb {
        justify-content: space-between;
    }

    .ac {
        align-items: center;
    }

    #classlist {
        padding-top: $h-header;
    }

    .tips {
        text-align: center;
        padding: 20px/$ppr 0;
        color: #5e89ef;
    }

    .list {
        .item {
            background: #fff;
            padding: 20px/$ppr 32px/$ppr;
            border-bottom: 1px/$ppr solid #eaeaea;
            &:last-child {
                border-bottom: 0;
            }
            .title{
                min-width: 100px/$ppr;
            }
            .choose {
                color: #999;
                font-size: 24px/$ppr;
                &.active{
                    color: #333;
                }
                .icon_right {
                    width: 14px/$ppr;
                    height: 26px/$ppr;
                    margin-left: 15px/$ppr;
                }
            }
        }
    }
    .btn{
        margin:100px/$ppr 32px/$ppr;
        background:#DCDCDC;
        height: 96px/$ppr;
        line-height: 96px/$ppr;
        color: #999;
        border-radius: 96px/$ppr;
        text-align: center;
        font-size: 28px/$ppr;
        &.active{
            background:#5e89ef;
            color: #fff;
        }
    }

</style>